import React, { Component } from 'react'

import * as Constants from '../../../helpers/Constants'

class BookingButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false
    }
  }

  getStyle() {
    const { hover } = this.state
    const { className = 'primary' } = this.props
    switch (className) {
      case 'primary':
        return { backgroundColor: hover ? '#77d8f4' : '#3fa6c1' }
      case 'success':
        return {
          backgroundColor: hover
            ? Constants.WHITE_LABEL.colors.primaryHover
            : Constants.WHITE_LABEL.colors.primary
        }
      case 'warning':
        return {
          backgroundColor: hover
            ? Constants.WHITE_LABEL.colors.warningHover
            : Constants.WHITE_LABEL.colors.warning,
          cursor: 'not-allowed'
        }
      default:
    }
  }

  render() {
    const {
      header = '',
      onClick = () => {},
      className = 'primary'
    } = this.props
    return (
      <a
        style={this.getStyle()}
        className={'BookingSchemeColumn'}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => (className === 'warning' ? {} : onClick())}
      >
        <h4 style={{ color: 'white', textAlign: 'center' }}>
          {header.toUpperCase()}
        </h4>
      </a>
    )
  }
}

export { BookingButton }



// WEBPACK FOOTER //
// ./src/components/common/bookingSchemeComponents/BookingButton.js